// src/components/style.js
import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  wrapper: {
    paddingRight: 80,
    paddingLeft: 80,
    overflowY: 'auto',
  },
  section: {
    marginTop: '2rem',
    marginBottom: '2rem',
  },
  heading: {
    marginBottom: '1rem',
    fontSize: 20,
    fontWeight: 500,
  },
  subtitle: {
    marginBottom: '0.75rem',
  },
  list: {
    paddingLeft: '1.5rem',
    marginBottom: '1.5rem',
  },
  listItem: {
    display: 'list-item',
    marginBottom: '0.5rem',
  },
  paragraph: {
    marginBottom: '1rem',
  },
  textStyle1: {
    // match your existing Text style for lists
  },
  tableContainer: {
    marginBottom: '1.5rem',
  },
}));
